import React from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';

import { useProjectTags } from '@/services/project-tags';
import { ProjectTagType } from '@/types';
import { FilterDropDown } from '@ygtechnologies/bygr-frontend-component-library';

interface TagFilterProps {
    projectId?: number;
    value?: number[];

    onChange: (value: number[]) => void;
}

export const TagFilter: React.FC<TagFilterProps> = ({ projectId, value = [], onChange }) => {
    const { data: tags } = useProjectTags(projectId, ProjectTagType.Room);

    const data = (tags ?? []).map((tag) => ({ id: tag.id, name: tag.label }));

    return (
        <FilterDropDown
            placeholder={t`Any tag`}
            label={<Trans>Tags</Trans>}
            data={data}
            value={value}
            onChange={(v) => onChange(v.map((x) => x.id))}
        />
    );
};
